import React from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import MenuButton from '../app/styles/components/MenuButton'
import MyAccountNav from '../components/MyAccountNav'
import Window from '../utils/Window';
import { useSelector } from 'react-redux';
import { selectToken } from '../features/user/userSlice';
import CustomerObj from '../features/customer/customerObj';
import { selectCustomer } from '../features/customer/customerSlice';
import { selectGuestEmail } from '../features/guest/guestSlice';
import MyAccountPage from './MyAccountPage';
import { useNavigate } from 'react-router-dom';
import { selectIsMobileRoute } from '../features/mobile/mobileSlice';

export default function FeedBackSurveys() {
    const navigate = useNavigate();
    const token = useSelector(selectToken);
    const guestEmail = useSelector(selectGuestEmail);
    const customer = new CustomerObj(useSelector(selectCustomer));
    const AppURL = useSelector(selectIsMobileRoute);
    const billing_info = Object.keys(customer.data).length > 0 ? customer.data.billing : {};
    const QURLParams = AppURL ? `/?${AppURL}` : '/';

    const initialEmailValue = () => {
        if (token && billing_info && billing_info.email) {
            return 'email' in billing_info ? billing_info.email : ''
        } else if (token && customer && customer?.data?.email) {
            return customer?.data ? customer?.data?.email : ''
        }

        return guestEmail;
    }
    const userEmail = initialEmailValue();

    if (!token || !Window.isMobile()) {
        if (!Window.isMobile()) {
            navigate(`/my-account${QURLParams}`);
        }

        return (
            <MyAccountPage />
        )
    }

    return (
        <Container fluid="lg" className='refer-a-friend-page'>
            <Row>
                {Window.isMobile() ?
                    <>
                        <Col xs={3} className='p-0 px-2 pt-2'>
                            <MenuButton />
                        </Col>
                        <Col xs={9} className='p-0 px-3 d-flex align-items-center justify-content-end'>
                            <span className="text-uppercase fw-400 fs-32px font-league-gothic">FEEDBACK SURVEYS</span>
                        </Col>
                    </> :
                    <Col sm={12} md={3}>
                        <MyAccountNav />
                    </Col>}
                <Col xs={12} lg={4} className='mb-4 text-center'>
                    <Card className='text-black font-barlow fw-700 border border-2 border-black  m-1pct p-3 fs-20px h-100'>
                        <h2 className='text-center mb-4'>Quality Feedback</h2>
                        <p className='font-barlow fs-20px'>
                            Rate your experience and tell us about your meal quality. This helps
                            us perfect our menu to better serve you!
                        </p>
                        <div className='d-grid'>
                            <Button
                                variant="dark"
                                size="lg"
                                className='bg-black'
                                onClick={() => {
                                    window.open(`https://www.surveymonkey.com/r/QMJPZM5?email=${userEmail}`, '_blank')
                                }}
                            >
                                Feedback Form
                            </Button>
                        </div>
                    </Card>
                </Col>
                <Col xs={12} lg={4} className='mb-4 text-center'>
                    <Card className='text-black font-barlow fw-700 border border-2 border-black  m-1pct p-3 fs-20px h-100'>
                        <div className='my-auto'>
                            <h2 className='mb-4'>Website Experience</h2>
                            <p className='font-barlow fs-20px'>
                                Tell us about your website ordering experience. This helps us
                                perfect our site  to better serve you!
                            </p>
                            <div className='d-grid'>
                                <Button
                                    variant="dark"
                                    size="lg"
                                    className='bg-black'
                                    onClick={() => {
                                        window.open(`https://www.surveymonkey.com/r/QT28GT7?email=${userEmail}`, '_blank')
                                    }}
                                >
                                    Fill Out Survey
                                </Button>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col xs={12} lg={4} className='mb-4 w-min-content text-center'>
                    <Card className='text-black font-barlow fw-700 border border-2 border-black  m-1pct p-3 fs-20px h-100'>
                        <div className='my-auto'>
                            <h2 className='mb-4'>Order Planner Experience</h2>
                            <p className='font-barlow fs-20px'>
                                Tell us about your experience using the Order Planner so we can continue to improve your experience!
                            </p>
                            <div className='d-grid'>
                                <Button
                                    variant="dark"
                                    size="lg"
                                    className='bg-black'
                                    onClick={() => {
                                        window.open(`https://www.surveymonkey.com/r/JCWDCVY?email=${userEmail}`, '_blank')
                                    }}
                                >
                                    Give Order Planner Feedback
                                </Button>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col xs={12} lg={4} className='mb-4'>
                    <Card className='text-black font-barlow fw-700 border border-2 border-black m-1pct p-3 fs-20px h-100'>
                        <div className='my-auto'>
                            <h2 className='text-center mb-4'>Support</h2>
                            <div className='d-grid gap-3'>
                                <Button
                                    variant="dark"
                                    size="lg"
                                    className='bg-black'
                                    onClick={() => {
                                        window.open("https://mightymeals.freshdesk.com/support/solutions/61000048924", '_blank')
                                    }}
                                >
                                    View FAQs
                                </Button>
                                <Button
                                    variant="dark"
                                    size="lg"
                                    className='bg-black'
                                    onClick={() => {
                                        window.open("https://mightymeals.freshdesk.com/support/home", '_blank')
                                    }}
                                >
                                    Contact Us
                                </Button>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
